import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { IdAndFinancialInformation } from './idAndFinancialInformation';
import { useStore } from '@roc/client-portal-shared/hooks';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type IdAndFinancialInformationDialogProps = {
  open: boolean;
  borrowerId: number;
  loan?: any;
  handleClose: () => void;
  refreshLoan?: () => void;
  document: Document;
};

export const IdAndFinancialInformationDialog = observer((props: IdAndFinancialInformationDialogProps) => {
  const { open, borrowerId, loan, handleClose, refreshLoan, document } = props;
  const taskId = document?.taskId;

  const { borrowerSetupToDoStore, identityCheckStore } = useStore();
  const onClose = () => {
    borrowerSetupToDoStore.reset();
    identityCheckStore.reset();
    handleClose();
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          maxWidth={'lg'}
          open={open}
          title='Borrower Identity Verification'
          handleClose={onClose}
          dialogContent={
            <IdAndFinancialInformation
              borrowerId={borrowerId}
              loan={loan}
              handleClose={onClose}
              refreshLoan={refreshLoan}
            />
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          maxWidth={'lg'}
          open={open}
          title='Borrower Identity Verification'
          handleClose={onClose}
          dialogContent={
            <IdAndFinancialInformation
              borrowerId={borrowerId}
              loan={loan}
              handleClose={onClose}
              refreshLoan={refreshLoan}
            />
          }
          removeContentBox
        />
      )}
    </>
  );
});

export default IdAndFinancialInformationDialog;